import { __exports as assignmentFilter } from "../../../../../../_virtual/assignment-filter.js";
import { __require as requireCache } from "../util/cache.js";
import { __require as requireAssignmentService } from "./assignment-service.js";
var hasRequiredAssignmentFilter;
function requireAssignmentFilter() {
  if (hasRequiredAssignmentFilter) return assignmentFilter;
  hasRequiredAssignmentFilter = 1;
  Object.defineProperty(assignmentFilter, "__esModule", { value: true });
  assignmentFilter.InMemoryAssignmentFilter = void 0;
  const cache_1 = requireCache();
  const assignment_service_1 = requireAssignmentService();
  class InMemoryAssignmentFilter {
    constructor(size, ttlMillis = assignment_service_1.DAY_MILLIS) {
      this.cache = new cache_1.Cache(size, ttlMillis);
    }
    shouldTrack(assignment) {
      if (Object.keys(assignment.results).length === 0) {
        return false;
      }
      const canonicalAssignment = assignment.canonicalize();
      const track = this.cache.get(canonicalAssignment) == void 0;
      if (track) {
        this.cache.put(canonicalAssignment, 0);
      }
      return track;
    }
  }
  assignmentFilter.InMemoryAssignmentFilter = InMemoryAssignmentFilter;
  return assignmentFilter;
}
export {
  requireAssignmentFilter as __require
};
//# sourceMappingURL=assignment-filter.js.map
